import { observer } from 'mobx-react';
import menuGroupImprovementStore from './store/menuGroupImprovementStore';
import MenuGroupImprovementList from './containers/MenuGroupImprovementList/MenuGroupImprovementList';
import { SCREENS } from 'src/constants/screens';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import Headers from 'src/view/containers/Headers/Headers';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import './style.scss';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';

const MenuGroupImprovementScreen = observer((): JSX.Element => {
  return (
    <>
      <Headers>
        <HeaderBack title="menu_healthchecker_page_hdr" isLoading={menuGroupImprovementStore.isLoading} path={SCREENS.MENU_GROUPS()} />
      </Headers>
      <div className="d-flex flex-column flex-grow-1 mt-6">
        <MenuGroupImprovementList />
        {!menuGroupImprovementStore.isRequestWasSended && (
          <Button
            title={localeStore.t('menu_healthchecker_check_menu_btn')}
            onClick={menuGroupImprovementStore.getMenuGroupImprovementList}
            loading={menuGroupImprovementStore.isLoading}
            style={{ pointerEvents: 'auto' }}
            className="menu-group-edit__check-btn"
          />
        )}
      </div>
      <LoadingOverlay visible={menuGroupImprovementStore.isLoading} refreshing />
    </>
  );
});

export default MenuGroupImprovementScreen;
